<template>
  <div class="pt-10">
    <v-row align="center" class="fill-height ma-0" justify="center">
      <ResHubLogo />
    </v-row>
    <Loader v-if="isLoading" style="height: 200px;" />
    <v-row v-else class="mx-10 px-0 mx-0 justify-center">
      <v-col lg="5" class="pt-8">
        <h3 v-if="isCompleted" class="text-center" style="color:#71bf7a">
          <b>
            {{$t('ServiceList.ServiceRequestSuccessfullyCompleted')}}
          </b>
        </h3>
        <h3 v-else class="text-error text-center">
          <b>
            {{$t('ServiceList.UnableToCompleteServiceRequest')}}
          </b>
        </h3>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import * as firebase from "firebase/app";
import ResHubLogo from "@/views/login/ResHubLogo.vue";
import { getRegionName } from "@/utils/functionsRegion";
import Loader from "@/components/loader/Loader.vue";

export default {
  components: {
    ResHubLogo,
    Loader
  },
  data() {
    return {
      isLoading: false,
      isCompleted: false
    };
  },
  async mounted() {
    this.isLoading = true;

    if (!this.$route.params.completeStatusToken || !this.$route?.params?.completeStatusToken?.length) {
      this.isCompleted = false
      return
    }

    const response = await firebase.app().functions(getRegionName())
      .httpsCallable('serviceRequest-complete')({
        completeStatusToken: this.$route.params.completeStatusToken
      });

    this.isLoading = false

    if (response.data?.data?.status === 200) {
      this.isCompleted = true
    }
    else {
      this.isCompleted = false
    }
  }
};
</script>
